<template>
    <v-container fluid class="py-0 px-0" ref="container">
        <v-tabs
            ref="tabs"
            active-class="white"
            background-color="grey lighten-3"
            hide-slider
        >
            <v-tab
                v-if="purchasingAccountantPermission"
                :to="{
                    name: 'accountant-purchases',
                }"
            >
                With PO
            </v-tab>
            <v-tab
                v-if="purchasingAccountantWithOutPoPermission"
                :to="{
                    name: 'accountant-no-requisitions',
                }"
            >
                Without PO
            </v-tab>
            <v-tab
                v-if="purchasingAccountantWithOutPoPermission"
                :to="{
                    name: 'accountant-foreign-trade',
                }"
            >
                FOREIGN TRADE
            </v-tab>
            <v-tab
                v-if="purchasingAccountantHistoryPermission"
                :to="{
                    name: 'accountant-history',
                }"
            >
                HISTORY
            </v-tab>
            <v-tab v-if="purchasingAccountantHistoryPermission" :to="{
                name: 'accountant-invoice-history',
            }">
                Invoices Archive
            </v-tab>
        </v-tabs>
        <v-card flat>
            <v-card-text
                class="overflow-y-auto px-4 pt-4"
                :style="{ height: `${height}px` }"
            >
                <router-view
                    :isPurchaseApprover="isPurchaseApprover"
                    :purchaseApproverProjects="purchaseApproverProjects"
                />
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import API from '@/services/api'

export default {
    name: 'Accountant',
    data: () => ({
        loading: true,
        height: 0,
        pricingPermission: undefined,
        preApprovalPermission: undefined,
        approvalPermission: undefined,
        inTransitPermission: undefined,
        closedPermission: undefined,
        assignBuyerPermission: undefined,
        receivedPermission: undefined,
        purchasingAccountantPermission: undefined,
        purchasingAccountantWithOutPoPermission: undefined,
        purchasingAccountantHistoryPermission: undefined,
        allClosedPermission: undefined,
        purchasesStatusPermission: undefined,
        purchasesStatisticsPermission: undefined,
        allPurchasesPermission: undefined,
        isPurchaseApprover: false,
        purchaseApproverProjects: [],
    }),
    async mounted() {
        try {
            this.loading = true
            this.onResize()
            const {
                data: { user },
            } = await API.getMyInfo()
            this.purchasingAccountantPermission = user.permissions.includes(
                'withPoAccounting'
            )
            this.purchasingAccountantWithOutPoPermission = user.permissions.includes(
                'withOutPoAccounting'
            )
            this.purchasingAccountantHistoryPermission = user.permissions.includes(
                'accoutingHistory'
            )

            // get purchase approver projects
            const projects = await API.getLiteProjects({ all: true })
            for (const project of projects) {
                if (
                    project.purchaseApprovers &&
                    typeof project.purchaseApprovers === 'object' &&
                    Object.keys(project.purchaseApprovers).includes(user.id)
                ) {
                    this.purchaseApproverProjects.push({
                        id: project.id,
                        limit: project.purchaseApprovers[user.id],
                        currency: project.currency,
                    })
                }
            }
            if (this.purchaseApproverProjects.length > 0) {
                this.isPurchaseApprover = true
            }
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
    methods: {
        onResize() {
            const {
                container: { clientHeight: containerHeight },
                tabs: {
                    $el: { clientHeight: tabsHeight },
                },
            } = this.$refs
            this.height = window.innerHeight - containerHeight - tabsHeight - 25
        },
    },
}
</script>

<style></style>
